import { Component, OnInit, Inject, ChangeDetectorRef } from '@angular/core';
import { FormGroup, FormBuilder } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material';

import { Update } from '../../../../_models/update';
import { Template } from '../../../../_models/template';
import { Product } from '../../../../_models/product';
import { CardService } from '../../card.service';
import { CardSvg } from '../../../../_models/card-svg';


@Component({
  moduleId: module.id,
  selector: 'edit-card-component',
  templateUrl: 'edit-card.component.html',
  styleUrls: ['./edit-card.component.css']
})

export class EditCardComponent implements OnInit {
  public template: Template;
  public svg:string;
  public cardSVG:CardSvg;
  public newCard = false;
  public disableForm = false;
  public isCardAWalletOpener = false;
  public updateValuesForm:FormGroup;


  constructor(private formBuilder: FormBuilder, private changeDetectorRef: ChangeDetectorRef, public cardService: CardService,
              @Inject(MAT_DIALOG_DATA) public data: {template:Template, newCard: boolean}) {}

  ngOnInit():void {
    this.template = this.data.template;
    let templateSVG = this.template.svg;
    this.cardSVG = new CardSvg(this.template.svg);
    this.newCard = this.data.newCard;
    this.svg = ' ';
    this.svg = this.svg + templateSVG;
    this.isCardAWalletOpener = this.template.allow_second_product && this.template.require_store_price;
    // Get all formvalues for name + type (and if wallet opener aditional fields)
    let formValues = this.cardSVG.extractFormValues(this.isCardAWalletOpener);
    // Set the form
    this.updateValuesForm = this.formBuilder.group(formValues);
    this.updateValuesForm.valueChanges.subscribe(data => {
      // Add each update to svg, set SVG to template so other components are in sync
      let latestCardSVG = new CardSvg(this.template.svg);
      latestCardSVG.setValue(CardSvg.type_selector, data[CardSvg.type_selector]);
      latestCardSVG.setValue(CardSvg.brand_selector, data[CardSvg.brand_selector]);
      if (this.isCardAWalletOpener) {
        latestCardSVG.setValue(CardSvg.wallet_opener_type_1_selector, data[CardSvg.wallet_opener_type_1_selector]);
        latestCardSVG.setValue(CardSvg.wallet_opener_type_2_selector, data[CardSvg.wallet_opener_type_2_selector]);
      }
      this.template.svg = latestCardSVG.svg_html;
      this.updateSVGPreview(data);
    }
    );
    this.changeDetectorRef.detectChanges();
  }

  submitForm():Template {
    this.template.svg = this.svg;
    return this.template;
  }

  updateSVG(svg) {
    if (svg !== this.svg) {
      let newTemplate:Template = { ...this.template};
      newTemplate.svg = svg;
      this.template = newTemplate;
      this.svg = svg;
    }
  }

  updateTitle(title) {
    this.template.name = title;
  }

  updateSVGPreview(formData:any) {
    let container = document.createElement('div');
    container.innerHTML = this.svg;
    for (let key in this.updateValuesForm.controls) {
      let updatedValue = this.updateValuesForm.controls[key].value;
      let elementID = key;
      if (updatedValue === '') {
        container.querySelector(elementID).innerHTML = '&nbsp;';
      } else {
        container.querySelector(elementID).innerHTML = updatedValue;
      }
    }
    // Update image
    this.updateSVG(container.innerHTML);
    this.changeDetectorRef.detectChanges();
  }

  updateSecondProduct(input:Product) {
    // If product is being removed
    if (input === undefined) {
      this.template.second_product_id = undefined;
    } else {
      this.template.second_product_id = input.id;
    }
  }
}



// WEBPACK FOOTER //
// /app/src/app/hq/cards/modify-card/edit-card/edit-card.component.ts